import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addVatRate: 'Add VAT Rate',
    badge: 'New',
    cancel: 'Cancel',
    error: 'VAT couldn’t be saved, please try again',
    successAdd: 'VAT was successfully added',
    successDelete: 'VAT was successfully deleted',
    title: 'VAT',
    validate: 'Save',
  },
  fr: {
    addVatRate: 'Ajouter un taux de TVA',
    badge: 'Nouveau',
    cancel: 'Annuler',
    error: 'La TVA n’a pas pu être sauvegardée, veuillez réessayer',
    successAdd: 'La TVA a bien été ajoutée',
    successDelete: 'La TVA a bien été supprimée',
    title: 'TVA',
    validate: 'Valider',
  },
} as const);

export default locales;
